// Response-Interceptor für konsistente Toasts
import api from './api';
import { useToast } from '../composables/useToast';

let installed = false;

function install() {
  if (installed) return;
  installed = true;

  api.interceptors.response.use(
    (res) => res,
    (err) => {
      try {
        const toast = useToast();
        const status = err?.response?.status;
        const payload = err?.response?.data;
        const msg =
          payload?.error?.message ||
          payload?.message ||
          payload?.data?.message ||
          err?.message ||
          'Unbekannter Fehler';

        if (status === 401) {
          // Kein Toast: services/api.js meldet ab und leitet sofort zum Login um
        } else if (status === 403) {
          toast.warn('Du hast keine Berechtigung für diese Aktion.', 'Zugriff verweigert');
        } else if (status === 422) {
          toast.error(msg || 'Eingaben prüfen', 'Validierungsfehler');
        } else if (status >= 500) {
          toast.error('Serverfehler – bitte später erneut versuchen', 'Fehler');
        } else {
          toast.error(msg);
        }
      } catch {
        // Fallback: nichts tun, um zyklische Abhängigkeiten zu vermeiden
      }
      return Promise.reject(err);
    }
  );
}

install();
export default api;
